
import { MapPin, X } from 'lucide-react';

interface FilterLocationProps {
  location: string;
  onLocationChange: (location: string) => void;
}

const FilterLocation = ({ location, onLocationChange }: FilterLocationProps) => {
  return (
    <div className="space-y-2">
      <div className="flex items-center text-sm font-medium text-gray-600">
        <MapPin size={16} className="mr-1 text-medihub-primary" />
        <span>Helyszín</span>
      </div>
      <div className="relative">
        <input
          type="text"
          placeholder="Város vagy vármegye..."
          value={location}
          onChange={e => onLocationChange(e.target.value)}
          className="w-full px-3 py-2 rounded-lg border border-gray-200 text-sm focus:border-medihub-primary focus:ring-1 focus:ring-medihub-primary outline-none transition-all placeholder:text-slate-400 placeholder:italic placeholder:font-light"
        />
        {location && (
          <button
            onClick={() => onLocationChange('')}
            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
          >
            <X size={14} />
          </button>
        )}
      </div>
    </div>
  );
};

export default FilterLocation;
